var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-icon',_vm._g({attrs:{"left":_vm.left,"small":"","color":_vm.getStaffWorkType(_vm.type).color}},on),[_vm._v(_vm._s(_vm.getStaffWorkType(_vm.type).icon))]),(_vm.withTitle)?_c('span',[_vm._v(_vm._s(_vm.getStaffWorkType(_vm.type).title))]):_vm._e()]}}])},[_c('span',[_vm._v(_vm._s(_vm.getStaffWorkType(_vm.type).title))])])}
var staticRenderFns = []

export { render, staticRenderFns }